
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Box,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Button,
} from '@material-ui/core';

import { Select } from '../common/fields';

const CatalogFormPC1 = (props) => {
  const { t } = useTranslation();
  const { currentCountry, itemOwnerId, typeLanguages, status, onFormSubmit } = props;

  return (
    <form method="get" onSubmit={onFormSubmit}>
      <input type="hidden" name="ownerId" value={itemOwnerId} />
      <input type="hidden" name="type" value="pct" />
      <input type="hidden" name="subtype" value="full" />
      <Typography variant="h6" component="h2">{t('catalog:generateProductCatalog')}</Typography>
      <Box py={1}>
        <Select label={t('catalog:language')} name="language" defaultValue={currentCountry} options={typeLanguages.map(lang => ({label: lang.name, value: lang.id}))} required />
      </Box>
      <Box py={1}>
        <FormControl>
          <FormLabel id="target">{t('catalog:target')}</FormLabel>
          <RadioGroup
            aria-labelledby="target"
            defaultValue="web"
            name="target"
            required
            row
          >
            <FormControlLabel value="web" control={<Radio color="primary" />} label={t('catalog:web')} />
            <FormControlLabel value="print" control={<Radio color="primary" />} label={t('catalog:print')} />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box py={1}>
        <Button type="submit" variant="contained" color="primary" disabled={status === 'processing'}>{t('catalog:generate')}</Button>
      </Box>
    </form>
  );
}

export default CatalogFormPC1;
